// Inductance units with conversion factors to henry (H)
export const inductanceUnits = [
  { id: 'henry', name: 'Henry', symbol: 'H', plural: 'Henries', factor: 1 },
  { id: 'kilohenry', name: 'Kilohenry', symbol: 'kH', plural: 'Kilohenries', factor: 1e3 },
  { id: 'millihenry', name: 'Millihenry', symbol: 'mH', plural: 'Millihenries', factor: 1e-3 },
  { id: 'microhenry', name: 'Microhenry', symbol: 'µH', plural: 'Microhenries', factor: 1e-6 },
  { id: 'nanohenry', name: 'Nanohenry', symbol: 'nH', plural: 'Nanohenries', factor: 1e-9 },
  { id: 'picohenry', name: 'Picohenry', symbol: 'pH', plural: 'Picohenries', factor: 1e-12 },
  { id: 'weber-per-ampere', name: 'Weber/Ampere', symbol: 'Wb/A', plural: 'Webers/Ampere', factor: 1 },
  { id: 'abhenry', name: 'Abhenry', symbol: 'abH', plural: 'Abhenries', factor: 1e-9 },
  { id: 'stathenry', name: 'Stathenry', symbol: 'statH', plural: 'Stathenries', factor: 8.987552e11 },
];

export const popularInductanceConversions = [
  { from: 'henry', to: 'millihenry' },
  { from: 'millihenry', to: 'henry' },
  { from: 'millihenry', to: 'microhenry' },
  { from: 'microhenry', to: 'millihenry' },
  { from: 'microhenry', to: 'nanohenry' },
  { from: 'henry', to: 'microhenry' },
];

export const getUnitById = (id) => inductanceUnits.find(unit => unit.id === id);

export const convertInductance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert inductance units and learn the conversion formula.`;
};
